/* eslint-disable @typescript-eslint/no-explicit-any */
// Loose `any` on normalize() row inputs + response generics: BE field-shape is
// not codegen-derived (migration plan: "Loose types over generated codegen types").
import instance, { ADMIN_PREFIX } from 'services/api';
import {
  InvoiceTemplate,
  InvoiceTemplateInput,
  InvoiceTemplateKey,
  InvoiceTemplateListResponse
} from 'types/api/invoiceTemplates';

const normalizeKey = (row: any): InvoiceTemplateKey => ({
  id: Number(row.id),
  key: row.key,
  template_id: row.template_id ?? row.templateId,
  label: row.label ?? {},
  type: Number(row.type),
  required: !!row.required,
  sort_index: row.sort_index ?? row.sortIndex ?? 0
});

const normalize = (row: any): InvoiceTemplate => ({
  id: Number(row.id),
  name: row.name,
  organization_id: row.organization_id ?? row.organizationId ?? null,
  created_at: row.created_at ?? row.createdAt ?? '',
  keys: Array.isArray(row.keys) ? row.keys.map(normalizeKey) : []
});

export const fetchInvoiceTemplates = async (query: {
  page?: number;
  limit?: number;
}): Promise<InvoiceTemplateListResponse> => {
  const res = await instance.get<{ results: any[]; total: number }>(
    `${ADMIN_PREFIX}/invoice/template`,
    {
      params: {
        page: query.page ?? 1,
        limit: query.limit ?? 10
      }
    }
  );

  return {
    results: (res.data.results ?? []).map(normalize),
    total: res.data.total ?? 0
  };
};

export const fetchInvoiceTemplateById = async (
  id: string | number
): Promise<InvoiceTemplate> => {
  const res = await instance.get<any>(`${ADMIN_PREFIX}/invoice/template/${id}`);

  return normalize(res.data);
};

export const createInvoiceTemplate = (input: InvoiceTemplateInput) =>
  instance.post<InvoiceTemplate>(`${ADMIN_PREFIX}/invoice/template`, input);

export const updateInvoiceTemplate = (
  id: string | number,
  input: InvoiceTemplateInput
) =>
  instance.put<InvoiceTemplate>(
    `${ADMIN_PREFIX}/invoice/template/${id}`,
    input
  );
